import React from 'react';
import Lock from '@mui/icons-material/Lock';
let yup = require('yup');

const newPasswordConfirmInput = {
  label: 'Confirm New Password',
  type: 'password',
  yup: yup
  .string()
  .oneOf([yup.ref('newPwd'), null], "Passwords don't match")
  .required('Password confirm is required'),
  autocomplete: 'new-password',
  icon: <Lock/>,
};

export default newPasswordConfirmInput;